import turfObj from "@turf/buffer";

export default function buffer(feature, options) {
    return turfObj(feature, options);
};
